"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceService = void 0;
var qs_1 = __importDefault(require("qs"));
var ResourceService = /** @class */ (function () {
    function ResourceService(resourceName, httpClient) {
        this.resourceName = resourceName;
        this.httpClient = httpClient;
    }
    ResourceService.prototype.getAll = function () {
        return this.httpClient.get(this.getResourceUrl());
    };
    ResourceService.prototype.search = function (query) {
        var params = typeof query === 'string' ? query : qs_1.default.stringify(query);
        var url = this.getResourceUrl() + "?" + params;
        return this.httpClient.get(url);
    };
    ResourceService.prototype.get = function (id) {
        return this.httpClient.get(this.getResourceUrl(id));
    };
    ResourceService.prototype.create = function (body) {
        return this.httpClient.post(this.getResourceUrl(), body);
    };
    ResourceService.prototype.update = function (id, body) {
        return this.httpClient.put(this.getResourceUrl(id), body);
    };
    ResourceService.prototype.delete = function (id) {
        return this.httpClient.delete(this.getResourceUrl(id));
    };
    ResourceService.prototype.getResourceUrl = function (id) {
        var resource = id
            ? this.resourceName + "/" + id
            : this.resourceName;
        return "api/" + resource;
    };
    return ResourceService;
}());
exports.ResourceService = ResourceService;
